<template>
  <div class="backdrop" v-if="isOpen" @click.self="close">
    <div class="popup">
      <div class="popup__icon" v-if="!withoutIcon">
        <slot name="icon">
          <svg
            width="32"
            height="28"
            viewBox="0 0 32 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M30.6088 0.340515C31.5277 0.953429 31.7758 2.19522 31.1629 3.11414L15.0873 27.2156L1.03726 12.1694C0.28339 11.362 0.326718 10.0965 1.13403 9.34259C1.94135 8.58872 3.20694 8.63205 3.9608 9.43937L14.5629 20.7932L27.8352 0.894583C28.4481 -0.024335 29.6899 -0.2724 30.6088 0.340515Z"
              fill="#F2F2F2"
            />
          </svg>
        </slot>
      </div>
      <slot name="header" :close="close"></slot>
      <div class="popup__content">
        <slot name="content"></slot>
      </div>
      <div class="popup__actions">
        <slot name="actions" :close="close" :confirm="confirm"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BasePopup",

  props: {
    withoutIcon: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  popupController: {},

  mounted() {
    document.addEventListener("keydown", this.handleKeyDown);
  },

  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },

  methods: {
    async open() {
      document.body.style.overflow = "hidden";
      const popupPromise = new Promise((resolve, reject) => {
        this.$options.popupController = { resolve, reject };
      });
      this.isOpen = true;

      return popupPromise;
    },

    confirm(confirmValue = true) {
      this.$options.popupController.resolve(confirmValue);
      this.isOpen = false;
      document.body.style.overflow = "auto";
    },

    close() {
      document.body.style.overflow = "auto";
      this.$options.popupController.resolve(false);
      this.isOpen = false;
    },

    hide() {
      this.$emit("hide", false);
    },

    handleKeyDown(e) {
      if (this.isOpen && e.key === "Escape") {
        this.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0, 0, 0, 0.2);
}

.popup {
  position: relative;
  max-width: 100%;
  background: #ffffff;
  border-radius: 30px;
  padding: 40px 20px 40px;
  box-shadow: 0px 20px 30px rgb(225 235 253 / 38%);

  &__icon {
    position: absolute;
    width: 70px;
    height: 70px;

    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #2b65eb;
    border-radius: 50%;
    top: -25px;
    left: 50%;
    transform: translateX(-50%);

    box-shadow: -10px 13px 26px rgba(43, 101, 235, 0.2),
      inset 0px -7px 0px rgba(0, 0, 0, 0.25);

    ::v-deep {
      svg {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  &__content {
    font-weight: 500;
    font-size: 16px;
    line-height: 28px;
    text-align: center;
    color: #27365b;
  }

  &__actions {
    display: flex;
    justify-content: center;

    &:empty {
      margin-top: 0;
    }
  }
}
</style>
